/**
 * Wall-clock time-of-day helpers shared by the schedule editors.
 *
 * Business hours, worker hours and time off all store "HH:mm" strings in the
 * salon's timezone (see {@link ./datetime}), and all three edit them with the
 * same half-hour dropdown.
 */

/** "00:00", "00:30", … "23:30" — the options in every schedule dropdown. */
export const TIME_OPTIONS: string[] = [];
for (let h = 0; h < 24; h++) {
  for (const m of [0, 30]) {
    TIME_OPTIONS.push(`${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`);
  }
}

/** "14:30" -> "2:30 PM". */
export function formatTime12(time24: string): string {
  const [h, m] = time24.split(':').map(Number);
  const period = h >= 12 ? 'PM' : 'AM';
  const hour12 = h === 0 ? 12 : h > 12 ? h - 12 : h;
  return `${hour12}:${String(m).padStart(2, '0')} ${period}`;
}
